// Config: Actions to trigger loading of local and external Sitecore texts.
import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;
type LoadConfig = import('../reducers/context').ContextReducer;

export interface LoadConfigAction extends Action<typeof actionTypes.LOAD_CONFIG> {
    type: typeof actionTypes.LOAD_CONFIG;
    payload: {
        config: LoadConfig['config'];
        localConfigData: LoadConfig['localConfigData'];
        appType: LoadConfig['appType'];
    };
}

export type ConfigActions = LoadConfigAction;

export const loadConfig = (
    config: LoadConfig['config'],
    localConfigData: LoadConfig['localConfigData'],
    appType: LoadConfig['appType'],
): LoadConfigAction => ({
    type: actionTypes.LOAD_CONFIG,
    payload: { config, localConfigData, appType },
});
